(function () {
  const STORAGE_KEY = 'genderCategory';
  const VALID_CATEGORIES = ['women','men', 'fragrances', 'beauty', 'kids','sweaters'];

  function getDefault() {
    return window.innerWidth < 1025 ? 'women' : 'women';
  }

  function getActive() {
    var saved = localStorage.getItem(STORAGE_KEY);
    return VALID_CATEGORIES.indexOf(saved) > -1 ? saved : getDefault();
  }

  function syncCategoryUI(category) {
    document.documentElement.setAttribute('data-gender', category);

    document.querySelectorAll('[data-gender-tab]').forEach(function (btn) {
      btn.setAttribute('aria-selected', btn.dataset.genderTab === category ? 'true' : 'false');
    });
  }

  function reinitSliders(container) {
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        if (window.Flickity) {
          container.querySelectorAll('.flickity-enabled').forEach(function (el) {
            var flkty = Flickity.data(el);
            if (flkty) {
              flkty.resize();
              flkty.reposition();
            }
          });
        }
        window.dispatchEvent(new Event('resize'));
      });
    });
  }

  function applyCategory(category) {
    if (VALID_CATEGORIES.indexOf(category) === -1) return;
    localStorage.setItem(STORAGE_KEY, category);

    // One attribute change â€” CSS instantly handles all hiding/showing
    syncCategoryUI(category);

    document.querySelectorAll('.bonanza-navigation').forEach(function (menu) {
      menu.classList.remove('bonanza-has-open-menu');
      menu.querySelectorAll(':scope > .sr4-menu-item.is--opend').forEach(function (item) {
        item.classList.remove('is--opend');
        var submenu = item.querySelector(':scope > .sr4-sub-menu');
        if (submenu) submenu.removeAttribute('style');
      });
    });

    // Reinit Flickity only on newly visible sections
    document.querySelectorAll('[data-gender-section="' + category + '"]').forEach(function (el) {
      reinitSliders(el);
    });

    document.dispatchEvent(new CustomEvent('genderChanged', { detail: { category: category } }));
  }

  // Tab click handler. Delegation keeps it working after Kalles AJAX reloads the menu.
  document.addEventListener('click', function (e) {
    var tab = e.target.closest('[data-gender-tab]');
    if (tab) {
      e.preventDefault();
      applyCategory(tab.dataset.genderTab);
    }
  });

  function initCategoryState() {
    var category = getActive();
    syncCategoryUI(category);

    // Reinit sliders for the default visible sections
    setTimeout(function () {
      document.querySelectorAll('[data-gender-section="' + category + '"]').forEach(function (el) {
        reinitSliders(el);
      });
    }, 300);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCategoryState);
  } else {
    initCategoryState();
  }

  var categoryObserver = new MutationObserver(function (mutations) {
    var hasNewTabs = mutations.some(function (mutation) {
      return Array.from(mutation.addedNodes).some(function (node) {
        if (node.nodeType !== 1) return false;
        return node.matches('[data-gender-tab]') || node.querySelector('[data-gender-tab]');
      });
    });

    if (hasNewTabs) syncCategoryUI(getActive());
  });

  function observeCategoryTabs() {
    if (document.body) categoryObserver.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observeCategoryTabs);
  } else {
    observeCategoryTabs();
  }

  // Re-run after customizer reloads a section
  document.addEventListener('shopify:section:load', function () {
    applyCategory(getActive());
  });

})();

(function () {
  function closeTopLevel(item) {
    var menu = item.closest('.bonanza-navigation');
    if (!menu) return;
    item.classList.remove('is--opend');
    var submenu = item.querySelector(':scope > .sr4-sub-menu');
    if (submenu) submenu.removeAttribute('style');
    menu.classList.remove('bonanza-has-open-menu');
  }

  function syncMenuState(item) {
    var menu = item.parentElement;
    if (!menu || !menu.classList.contains('bonanza-navigation')) return;
    if (!item.hasAttribute('data-gender-nav')) return;

    if (item.classList.contains('is--opend')) {
      Array.from(menu.children).forEach(function (sibling) {
        if (sibling !== item && sibling.classList && sibling.classList.contains('is--opend')) {
          sibling.classList.remove('is--opend');
          var siblingMenu = sibling.querySelector(':scope > .sr4-sub-menu');
          if (siblingMenu) siblingMenu.removeAttribute('style');
        }
      });
      menu.classList.add('bonanza-has-open-menu');

      if (window.innerWidth < 1025) {
        var groups = item.querySelectorAll(':scope > .sr4-sub-menu > .sr4-menu-item-has-children');
        groups.forEach(function (group, index) {
          group.classList.toggle('is--opend', index === 0);
          var childMenu = group.querySelector(':scope > .sr4-sub-sub-menu');
          if (childMenu) childMenu.style.display = index === 0 ? 'block' : 'none';
        });
      }
    } else if (!menu.querySelector(':scope > .sr4-menu-item.is--opend')) {
      menu.classList.remove('bonanza-has-open-menu');
    }
  }

  var observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
        syncMenuState(mutation.target);
      }
      mutation.addedNodes.forEach(function (node) {
        if (node.nodeType !== 1) return;
        var items = node.matches && node.matches('.bonanza-navigation > .sr4-menu-item-has-children[data-gender-nav]')
          ? [node]
          : node.querySelectorAll ? node.querySelectorAll('.bonanza-navigation > .sr4-menu-item-has-children[data-gender-nav]') : [];
        items.forEach(function (item) {
          observer.observe(item, { attributes: true, attributeFilter: ['class'] });
        });
      });
    });
  });

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.bonanza-navigation > .sr4-menu-item-has-children[data-gender-nav]').forEach(function (item) {
      observer.observe(item, { attributes: true, attributeFilter: ['class'] });
      syncMenuState(item);
    });
    observer.observe(document.body, { childList: true, subtree: true });
  });

  document.addEventListener('click', function (event) {
    if (window.innerWidth >= 1025) return;

    var trigger = event.target.closest('#sr4-menu-drawer .bonanza-navigation .sr4-menu-item-has-children > a');
    if (!trigger) return;

    var currentItem = trigger.parentElement;
    var currentList = currentItem.parentElement;
    if (!currentList || currentList.classList.contains('bonanza-navigation')) return;

    currentList.querySelectorAll(':scope > .sr4-menu-item-has-children.is--opend').forEach(function (sibling) {
      if (sibling === currentItem) return;

      sibling.classList.remove('is--opend');
      var siblingPanel = sibling.querySelector(':scope > ul');
      var siblingTrigger = sibling.querySelector(':scope > a');

      if (siblingTrigger) siblingTrigger.setAttribute('aria-expanded', 'false');
      if (!siblingPanel) return;

      if (window.jQuery) {
        window.jQuery(siblingPanel).stop(true, true).slideUp(200);
      } else {
        siblingPanel.style.display = 'none';
      }
    });

    requestAnimationFrame(function () {
      trigger.setAttribute('aria-expanded', currentItem.classList.contains('is--opend') ? 'true' : 'false');
    });
  }, true);

  document.addEventListener('click', function (event) {
    var back = event.target.closest('.back_and_cont');
    if (back) {
      event.preventDefault();
      event.stopPropagation();
      var openItem = back.closest('.bonanza-navigation > .sr4-menu-item.is--opend');
      if (openItem) closeTopLevel(openItem);
      return;
    }

    var topLink = event.target.closest('.bonanza-navigation > .sr4-menu-item-has-children[data-gender-nav] > a');
    if (topLink) {
      requestAnimationFrame(function () {
        syncMenuState(topLink.parentElement);
      });
    }
  });

  document.addEventListener('keydown', function (event) {
    if ((event.key === 'Enter' || event.key === ' ') && event.target.classList.contains('back_and_cont')) {
      event.preventDefault();
      var openItem = event.target.closest('.bonanza-navigation > .sr4-menu-item.is--opend');
      if (openItem) closeTopLevel(openItem);
    }
  });
})();
